import Rating from 'components/Rating';
import Text from 'components/Text';
import type { FieldKey } from 'hooks';
import { useNumberFormatter } from 'hooks/format';
import type { TemplateString } from 'types';
import { cn } from 'utils/classNames';
import { formatTemplate } from 'utils/format';

interface Props {
	className?: string;
	reviewCount: number;
	reviewCountText: TemplateString | FieldKey;
	reviewScore: number;
}

export default function RatingSummary({
	className,
	reviewCount,
	reviewCountText,
	reviewScore,
}: Props) {
	const formatNumber = useNumberFormatter();

	return (
		<div className={cn('flex items-center', className)}>
			<span
				className="mr-4 font-heading text-h1 text-[3.75rem] font-bold"
				// The score is part of the Rating component's screen reader text.
				aria-hidden="true"
			>
				{formatNumber(reviewScore)}
			</span>
			<div>
				<Rating score={reviewScore} size="medium" reviewCountVariant="hidden" />
				<Text as="pSmall" className="mt-1">
					{formatTemplate(reviewCountText, {
						reviewCount,
					})}
				</Text>
			</div>
		</div>
	);
}

RatingSummary.displayName = 'RatingSummary';
